
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PedidoOutERP } from 'src/app/model/pedido.out.ERP';
import { PedidoErpCambiado } from 'src/app/model/pedidoErpCambiado';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class PedidoOutERPService {
    private url : string = `${environment.HOST_ERP}`;

  //private url : string = "api_erp";
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

      
   

      


 

 SendPedidoOutErp(pedidoOut?: PedidoOutERP) {
    return this.http.post(`${this.url}/inventario`, pedidoOut);
  }

  SendPedidoOutErpCambiado(pedidoOutCambiado?: PedidoErpCambiado) {
    return this.http.post(`${this.url}/inventario`, pedidoOutCambiado);
  }



}